import { createFileRoute, Navigate } from '@tanstack/react-router';

import { PronunciationDictionaryEditor } from '@apps/web/components/settings/pronunciation_dictionary_editor';
import {
    SettingsLoadingState,
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';
import { useOrganizationVoiceSettings } from '@apps/web/swr_data_fetching/data_fetching_hooks';

export const Route = createFileRoute('/_app/settings/pronunciations')({
    component: PronunciationsSettingsPage,
});

function PronunciationsSettingsPage() {
    const {
        organizationId,
        gates,
        isLoading: areGatesLoading,
    } = useSettingsGates();
    const {
        data: voiceSettings,
        error,
        isLoading,
        mutate,
    } = useOrganizationVoiceSettings(organizationId);

    if (areGatesLoading || isLoading) {
        return <SettingsLoadingState />;
    }
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Pronunciations"
            description="Teach Phoebe how to say local towns, people, and agency names. Changes apply to new calls and don’t alter written transcripts."
        >
            {error || !voiceSettings ? (
                <p className="text-muted-foreground text-sm" role="alert">
                    Couldn’t load pronunciations. Nothing has changed.
                </p>
            ) : (
                <PronunciationDictionaryEditor
                    organizationId={organizationId}
                    initialEntries={
                        voiceSettings.pronunciation_dictionary ?? []
                    }
                    initialRevision={
                        voiceSettings.pronunciation_dictionary_revision
                    }
                    constraints={
                        voiceSettings.pronunciation_dictionary_constraints
                    }
                    onSaved={mutate}
                />
            )}
        </SettingsPageShell>
    );
}
